import { useState, useEffect } from 'react';
import Link from 'next/link';
import ReactDOMServer from 'react-dom/server';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ILiveChatBlock } from '@features/cms/typescript';
import styles from '@features/cms/components/pages/LiveChatBlock/LiveChatBlock.styles';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import { getLanguage } from '@utils/misc';
import scrollToElementById from '@utils/scrollToElementById';
import reusables from '@styles/theme/reusables';
type PropsType = {
  data: ILiveChatBlock;
};
const LiveChatBlock = ({
  data
}: PropsType) => {
  const {
    background,
    marginTop,
    marginBottom
  } = data;
  const {
    locale
  } = useRouter();
  const lang = getLanguage(locale);
  const [liveChatIsLoaded, setLiveChatIsLoaded] = useState(false);
  const {
    t
  } = useTranslation('layouts');
  let timeout: NodeJS.Timeout | null = null;
  const renderChatContent = () => <>
      <div sx={styles.heading} className="chat_heading" data-testid="live-chat-block-heading">
        <Heading h={4} headingType={4} mobile>
          {data.header}
        </Heading>
        {data.chatType === 'whatsapp' && <Icon size="40px" icon="Chat2" addSx={styles.headingIcon} />}
      </div>
      <div sx={styles.message} className="message">
        <p sx={styles.messageText}>{data.message}</p>
      </div>
    </>;
  const handleLiveChatLoaded = () => {
    if (typeof window !== 'undefined') {
      if (typeof window.LiveChatWidget !== 'undefined') {
        if (timeout) clearTimeout(timeout);
        timeout = null;
        setLiveChatIsLoaded(true);
      } else {
        timeout = setTimeout(() => {
          handleLiveChatLoaded();
        }, 400);
      }
    }
  };
  useEffect(() => {
    handleLiveChatLoaded();
    return () => timeout ? clearTimeout(timeout) : undefined;
  });
  const renderChat = () => {
    switch (lang) {
      case 'pl':
        return liveChatIsLoaded && <span data-id={data.link === '#livechat' ? 'VPeMw1qu1Gma' : 'eei5o0iwpA2Z'} className="livechat_button-contact" dangerouslySetInnerHTML={{
          __html: `<a onclick="event.preventDefault(); if (LiveChatWidget !== undefined) { LiveChatWidget.call('maximize');return false; }" href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12811512" >${ReactDOMServer.renderToStaticMarkup(renderChatContent())}</a>`
        }} />;
      case 'en':
        return liveChatIsLoaded && <span data-id="eTweuIOZMQQ" className="livechat_button-contact" dangerouslySetInnerHTML={{
          __html: `<a onclick="event.preventDefault(); if (LiveChatWidget !== undefined) { LiveChatWidget.call('maximize');return false; }" href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12811512" >${ReactDOMServer.renderToStaticMarkup(renderChatContent())}</a>`
        }} />;
      default:
        return <></>;
    }
  };
  return <section id={data.code} sx={styles.section(background, marginTop, marginBottom)} data-testid={data.code}>
      {data.link ? <>
          {data.link === '#livechat' || data.link === '#livechat-voxbox' ? renderChat() : <>
              {data.link.slice(0, 1) === '#' ? <button type="button" onClick={() => scrollToElementById(data.link.substring(1))} sx={{
          ...styles.content,
          ...reusables.unstyledButton
        }} data-testid={`${data.code}-scroll-button`}>
                  {renderChatContent()}
                </button> : <Link href={data.link === '' ? '#' : data.link} target="_blank" sx={styles.content} title={`${data.header} ${t('footer.links.opensInNewWindow')}`} data-testid="live-chat-block-link">
                  {renderChatContent()}
                </Link>}
            </>}
        </> : <span> {renderChatContent()}</span>}
    </section>;
};
export default LiveChatBlock;